// @ vendor
const Immutable = require('immutable');

// @ constants
const { PAYMENT_TYPE, FLOW_STEPS } = require('../../insuranceConstants/insuranceRequestHome');

const {
    INSURANCE_REQUEST_RELATED_RNC_WIZARD_VALIDATE_STEP,
    INSURANCE_REQUEST_RELATED_RNC_WIZARD_LOAD_STEP,
    INSURANCE_REQUEST_RELATED_RNC_WIZARD_SET_VISIBLE_STEP,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_BASIC_DATA_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_BASIC_DATA_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_HIGH_DATA_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_HIGH_DATA_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_DATA_FAILURE,
    INSURANCE_REQUEST_SELECT_BASIC_PLAN,
    INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_SET_LINKING_SUCCESS_TO_INITIAL,
    INSURANCE_REQUEST_RELATED_RNC_CANCEL_SIMULATION_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_CANCEL_SIMULATION_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_CANCEL_SIMULATION_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_SELECTED_PLAN,
    INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_WIZARD_SET_DATA,
    INSURANCE_REQUEST_RELATED_RNC_PRICING_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_PRICING_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_PRICING_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_FAILURE
} = require('../../insuranceConstants/actionTypes');

const setInitialState = () => {
    return Immutable.Map().merge({
        valid: false,
        isFetchingCoverages: false,
        coveragesAndPlansData: {},
        isFetchingDetailsMedium: false,
        isFetchingDetailsBasic: false,
        isFetchingDetailsHigh: false,
        isFetchingQuotation: false,
        quotationData: {},
        basicPlanModalValidation: false,
        coveragesDetailsBasicData: {},
        coveragesDetailsMediumData: {},
        coveragesDetailsHighData: {},
        errorDetails: '',
        insurancePlan: '',
        validUI: false,
        error: '',
        errorQuotation: '',
        pricing: {},
        isFetchingPricing: false,
        errorPricing: '',
        isFetchingSelectPlan: false,
        errorSelectPlan: '',
        isLinkingInProgress: false,
        islinkingSuccess: false,
        linkingError: '',
        cancelInProgress: '',
        cancelError: '',
        linkedSimulation: false,
        fieldErrors: false,
        paymentType: "",
        totalCost: null,
        showDetails: false,
        quotationRequestId: 0,
        isSaving: false,
        saveSuccess: true,
        saveError: '',
        isFetchingCurrentState: false,
        currentState: null,
        currentStateError: ''
    });
};

const validateStep = step => {
    const insurancePlan = step.get('insurancePlan');
    const isFetchingQuotation = step.get('isFetchingQuotation') || step.get('quotationData').isEmpty();
    const isFetchingSelectPlan = step.get('isFetchingSelectPlan');
    const isFetchingPricing = step.get('isFetchingPricing');
    const isFetchingCoverages = step.get('isFetchingCoverages') || step.get('coveragesAndPlansData').isEmpty();
    const isFetching = isFetchingQuotation || isFetchingSelectPlan || isFetchingCoverages || isFetchingPricing

    return step.merge({
        valid: false,
        validUI: insurancePlan !== '' && !isFetching,
        fieldErrors: true
    });
};

const insuranceRequestRelatedRNCWizardStep3 = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_RELATED_RNC_WIZARD_VALIDATE_STEP:
            return validateStep(state);

        case INSURANCE_REQUEST_RELATED_RNC_WIZARD_LOAD_STEP:
            const { payment: { paymentType } } = action.data;

            return state.merge({
                insurancePlan: action.data.insurancePlan,
                paymentType: state.get('paymentType') || paymentType || PAYMENT_TYPE.ANNUAL,
                valid: FLOW_STEPS[action.data.flowData.uiStep] > FLOW_STEPS.STEP_3,
                errorQuotation: '',
                errorDetails: '',
                error: '',
                linkingError: '',
                cancelError: '',
                errorSelectPlan: ''
            });

        case INSURANCE_REQUEST_RELATED_RNC_WIZARD_SET_VISIBLE_STEP:
            return state.merge({
                valid: false,
                fieldErrors: false,
                errorDetails: ''
            });

        case INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_REQUEST:
            return state.merge({
                isFetchingCoverages: true,
                fieldErrors: false,
                error: ''
            });

        case INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS:
            return state.merge({
                isFetchingCoverages: false,
                coveragesAndPlansData: action.data
            });

        case INSURANCE_REQUEST_RELATED_RNC_GET_COVERAGES_AND_PLANS_TABLE_FAILURE:
            return state.merge({
                isFetchingCoverages: false,
                error: action.data.error
            });

        case INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_REQUEST:
            return state.merge({
                isFetchingQuotation: true,
                errorQuotation: '',
                quotationRequestId: action.data.quotationRequestId
            });

        case INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_SUCCESS:
            return state.merge({
                isFetchingQuotation: false,
                quotationData: action.data
            });

        case INSURANCE_REQUEST_RELATED_RNC_COVERAGES_QUOTATION_FAILURE:
            return state.merge({
                isFetchingQuotation: false,
                errorQuotation: action.data.error
            });

        case INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST:
            return state.merge({
                isFetchingDetailsMedium: true
            });

        case INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS:
            return state.merge({
                isFetchingDetailsMedium: false,
                coveragesDetailsMediumData: action.data
            });

        case INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_BASIC_DATA_REQUEST:
            return state.merge({
                isFetchingDetailsBasic: true
            });

        case INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_BASIC_DATA_SUCCESS:
            return state.merge({
                isFetchingDetailsBasic: false,
                coveragesDetailsBasicData: action.data
            });

        case INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_HIGH_DATA_REQUEST:
            return state.merge({
                isFetchingDetailsHigh: true
            });

        case INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_HIGH_DATA_SUCCESS:
            return state.merge({
                isFetchingDetailsHigh: false,
                coveragesDetailsHighData: action.data
            });

        case INSURANCE_REQUEST_RELATED_RNC_COVERAGES_DETAIL_DATA_FAILURE:
            return state.merge({
                isFetchingDetailsHigh: false,
                errorDetails: action.data.error
            });
        case INSURANCE_REQUEST_SELECT_BASIC_PLAN:
            return state.merge({
                basicPlanModalValidation: true,
            });
        case INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_REQUEST:
            return state.merge({
                isFetchingSelectPlan: true,
                errorSelectPlan: ''
            });
        case INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_SUCCESS:
            return state.merge({
                isFetchingSelectPlan: false,
                insurancePlan: action.data.plan
            });
        case INSURANCE_REQUEST_RELATED_RNC_SELECT_PLAN_FAILURE:
            return state.merge({
                isFetchingSelectPlan: false,
                errorSelectPlan: action.data.error
            });
        case INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_REQUEST:
            return state.merge({
                isLinkingInProgress: true,
                linkingError: ''
            });
        case INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_SUCCESS:
            return state.merge({
                isLinkingInProgress: false,
                linkedSimulation: true,
                islinkingSuccess: true,
            });
        case INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_FAILURE:
            return state.merge({
                isLinkingInProgress: false,
                linkingError: action.data.error,
                linkedSimulation: false,
            });

        case INSURANCE_REQUEST_RELATED_RNC_SET_LINKING_SUCCESS_TO_INITIAL:
            return state.merge({
                linkedSimulation: false,
            })

        case INSURANCE_REQUEST_RELATED_RNC_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS:
            return state.merge({
                islinkingSuccess: false,
            })

        case INSURANCE_REQUEST_RELATED_RNC_CANCEL_SIMULATION_REQUEST:
            return state.merge({
                cancelInProgress: true,
                cancelError: ''
            });
        case INSURANCE_REQUEST_RELATED_RNC_CANCEL_SIMULATION_SUCCESS:
            return state.merge({
                cancelInProgress: false
            });
        case INSURANCE_REQUEST_RELATED_RNC_CANCEL_SIMULATION_FAILURE:
            return state.merge({
                cancelInProgress: false,
                cancelError: action.data.error
            });
        case INSURANCE_REQUEST_RELATED_RNC_SELECTED_PLAN:
            return state.merge({
                insurancePlan: action.data.insurancePlan,
            });

        case INSURANCE_REQUEST_RELATED_RNC_WIZARD_SET_DATA:
            return state.merge({
                ...action.data,
            });

        case INSURANCE_REQUEST_RELATED_RNC_PRICING_REQUEST:
            return state.merge({
                isFetchingPricing: true,
                fieldErrors: false,
                errorPricing: ''
            });

        case INSURANCE_REQUEST_RELATED_RNC_PRICING_SUCCESS:
            return state.mergeDeep({
                pricing: action.data,
                isFetchingPricing: false
            });

        case INSURANCE_REQUEST_RELATED_RNC_PRICING_FAILURE:
            return state.merge({
                errorPricing: action.data.error,
                isFetchingPricing: false
            });

        case INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_REQUEST:
            return state.merge({
                isSaving: true
            });

        case INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_SUCCESS:
            return state.mergeDeep({
                isSaving: false,
                saveSuccess: true
            });

        case INSURANCE_REQUEST_RELATED_RNC_SAVE_STEP_FAILURE:
            return state.merge({
                isSaving: false,
                saveSuccess: false,
                saveError: action.data.error
            });

        case INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_REQUEST:
            return state.merge({
                isFetchingCurrentState: true
            });

        case INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_SUCCESS:
            return state.mergeDeep({
                isFetchingCurrentState: false,
                currentState: action.data.current
            });

        case INSURANCE_REQUEST_RELATED_RNC_CURRENT_STATE_FAILURE:
            return state.merge({
                isFetchingCurrentState: false,
                currentState: null,
                currentStateError: action.data.error
            });

        default:
            return state;
    }
};

module.exports = insuranceRequestRelatedRNCWizardStep3;
